import { UnitType } from '@exodus/currency'

const name = 'waves'
const displayName = 'Waves'
const ticker = 'WAVES'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#5C98FF'
const gradientColors = ['#5C98FF', '#0362FC']
const gradientCoords = { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  shards: 0,
  WAVES: 8,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://wavesexplorer.com/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://wavesexplorer.com/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description: 'Waves is a cryptocurrency designed for large-scale business and consumer adoption.',
  reddit: 'https://www.reddit.com/r/Wavesplatform/',
  twitter: 'https://twitter.com/wavesplatform',
  website: 'https://wavesplatform.com/',
  telegram: 'https://t.me/wavesnews',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
